import { Bars3Icon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

import ASELogo from "../assets/ase-logo.png";

const MobileNavbar = ({ onHamburgerClicked }) => {
  return (
    <div className='fixed top-0 left-0 right-0 flex items-center justify-between md:hidden z-50 bg-white shadow-md px-4 py-2'>
      <Link to="/l">
        <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
      </Link>

      <Bars3Icon
        className='h-8 w-8 text-ase-blue'
        onClick={onHamburgerClicked}
      />
    </div>
  )
}

export default MobileNavbar;
